import React from "react";
const Ribbon = ({
  className,
  text,
  href
}: {
  className?: string | undefined;
  text: string;
  href?: string | undefined;
}) => <div className={`ribbon ribbon--mini ${className || ""}`.trim()} data-sentry-component="Ribbon" data-sentry-source-file="index.tsx">
    {href && <a href={href}>
        <span className="ribbon__text">{text}</span>
      </a> || <span className="ribbon__text">{text}</span>}
  </div>;
export default Ribbon;